<template>
  <div class="jps-blind-window-view" :class="{ 'jps-editable': editable }">
    <BaseBlindWindow :gap="6" :expansion-rate="4" :key="key">
      <BaseBlindWindowItem
        v-for="item in filteredItem"
        :key="item.key"
        :id="item.key"
      >
        <template #background="">
          <UiImageSelection
            :image="item.image"
            :type="noImgType(item)"
            :cover-override="true"
            class="jps-blind-window-view-item-background"
          />
          <UiButtonIcon
            v-if="editable"
            tag="button"
            class="jps-icon-button jps-sub-orange list-delete"
            @click.stop="emits('delete-item', item)"
            icon="mdi/close-circle"
          />
        </template>
        <template #contents="">
          <BaseLink
            v-bind="baseLinkProps(item)"
            @click="emits('show-modal', item)"
            class="jps-blind-window-view-item-contents"
            :show-icon="false"
          >
            <h2 class="is-size-5 has-text-weight-bold">
              {{ ls(item.title) }}
              <ListEditIcon :item="item" field="title" :editstate="editstate" />
              <ListEditIcon :item="item" field="url" :editstate="editstate" />
              <ListEditIcon :item="item" field="linkUrl" :editstate="editstate" />
              <ListEditIcon :item="item" field="image" :editstate="editstate" />
            </h2>
          </BaseLink>
        </template>
      </BaseBlindWindowItem>
    </BaseBlindWindow>
    <div v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  baseLinkProps,
  editable,
  addPartMsg,
  noImgType,
} = useCurationListView(props.editstate, props.def)

const key = ref('')

watch(
  () => props.items,
  () => {
    key.value = luId()
  },
)

const filteredItem = computed(() => {
  return props.items.filter(i => !i.readNext)
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-blind-window-view {
  height: 15rem;
  margin: 1.5rem;
  display: flex;
  align-items: center;
  overflow-x: hidden;

  @include is-mobile {
    margin: 1.5rem 0;
  }

  .list-delete {
    position: absolute;
    top: 2px;
    right: 6px;
    background: $jps-gray-50;
  }
  // 画像編集アイコンの位置調整
  :deep(.edit-image-static) {
    position: absolute;
    right: 6px;
    bottom: 2px;
  }
}

.jps-blind-window-view-item-contents {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 0.75rem;
  h2 {
    color: $white !important;
  }
}
</style>
